// src/helpers/settingsActions.ts
import { ISettingRequestParams } from '../types/crm-contact';
import { getCurrentGridColumns, applySettingsToGrid, fetchSettingsFromApi, saveGridSettings } from './settingsHelper';
import notify from 'devextreme/ui/notify';
import { SavedSetting } from '../components/library/page-setting/SettingsPopup';
import { ColumnSetting } from './columnSetting';
import { useTranslation } from 'react-i18next';

export const handleSettingsSaveAction = async ({
  gridInstance,
  settingPage,
  settingObject,
  settingName,
  settingRef,
  settingType,
  isDefault,
  settingJson, // eklenen opsiyonel parametre
  setSavedSettings,
  setSettingsPopupVisible,
}: {
  gridInstance: any;
  settingPage: string;
  settingObject: string;
  settingName: string;
  settingRef: number;
  settingType: number;
  isDefault: number;
  settingJson?: string;
  setSavedSettings: React.Dispatch<React.SetStateAction<SavedSetting[]>>;
  setSettingsPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  // Eğer yeni ayar ekleniyorsa grid'den alınan değer,
  // düzenleme modunda ise gönderilen settingJson (orijinal ayar) kullanılacak
  const finalSettingJson =
    settingRef === 0 ? JSON.stringify(getCurrentGridColumns(gridInstance)) : (settingJson || "");


  const params: ISettingRequestParams = {
    settingRef,
    settingType,
    settingPage,
    settingObject,
    settingName,
    settingJson: finalSettingJson,
    comment: "",
    isDefault,
    settingStatus: 1
  };

  try {
    const response = await saveGridSettings(params);
    if (response.resCode === 200) {

      if (settingRef !== 0) {
        setSavedSettings((prevSettings) =>
          prevSettings.map((s) =>
            s.settingRef === settingRef ? { ...s, settingName } : s
          )
        );
      } else {
        const settings = await fetchSettingsFromApi(settingPage, settingObject);
        setSavedSettings(settings);
      }
      // Eğer API response'unda settingJson dönmüyorsa, finalSettingJson kullanılacak.
      const settingJsonToApply = response.settingJson || finalSettingJson;
      applySettingsToGrid(gridInstance, settingJsonToApply);
      setSettingsPopupVisible(true);
    } else {
      notify(response.resMessage, "error", 2500);
    }
  } catch (error) {
    console.error("Error saving settings:", error);
    notify("Error saving settings", "error", 2500);
  }
};
